import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column align-items-center"
}
const _hoisted_2 = { class: "symbol symbol-60px h-60px w-60px" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "mt-5 mb-2" }
const _hoisted_5 = { class: "fs-8 text-gray-600 mb-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("اتصال")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("ورود")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Status = _resolveComponent("Status")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
        return (_openBlock(), _createBlock(_component_el_card, {
          key: item.id,
          class: "col-12 col-md-4 col-xl-3"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.platforms, (plat) => {
              return (_openBlock(), _createElementBlock("div", {
                key: plat.id
              }, [
                (plat.platform === 'instagram')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("img", {
                          src: plat.avatar ?? `/media/avatars/blank.png`,
                          alt: "Inboxino",
                          style: {"border-radius":"100px","border":"1px solid gold"}
                        }, null, 8, _hoisted_3)
                      ]),
                      _createElementVNode("h3", _hoisted_4, _toDisplayString(plat.platform_number), 1),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(item.name) + " ( " + _toDisplayString(item.bot_id) + " ) ", 1),
                      _createVNode(_component_Status, {
                        status: plat.status
                      }, null, 8, ["status"]),
                      (plat.status !== 'ready')
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/bot-connections/connect/${item.bot_id}/instagram`,
                            class: "btn btn-primary btn-sm mt-10 w-100"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (plat.status === 'ready')
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: `/automationList/${item.bot_id}/instagram`,
                            class: "btn btn-primary btn-sm mt-10 w-100"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 2
        }, 1024))
      }), 128))
    ])
  ]))
}